import {
  usePrevetAPI,
  VesselSensitivityInputObject,
  GetVesselSensitivityInputStruct,
} from "./usePrevetAPI"
import { useState, useCallback } from "react"
import axios from "axios"
import { toast } from "react-toastify"
import _ from "lodash"

export function useFetchVesselSensitivityInput() {
  const { getVesselSensitivityInput } = usePrevetAPI()
  const [vesselSensitivityInputData, setVesselSensitivityInputData] = useState<
    VesselSensitivityInputObject | null
  >(null)
  const [
    getVesselSensitivityInputLoading,
    setGetVesselSensitivityInputLoading,
  ] = useState<boolean>(false)

  async function fetchVesselSensitivityInput(
    vsi: GetVesselSensitivityInputStruct
  ) {
    setGetVesselSensitivityInputLoading(true)
    setVesselSensitivityInputData(null)

    try {
      const response = await getVesselSensitivityInput(vsi)
      if (response) {
        setVesselSensitivityInputData(response)
      }
    } catch (err: unknown) {
      const message = "Unable to load vessel sensitivity history."
      if (axios.isAxiosError(err)) {
        toast.warn(message, {
          position: "bottom-right",
          autoClose: 8000,
        })
      }
    } finally {
      setGetVesselSensitivityInputLoading(false)
    }
  }

  return {
    vesselSensitivityInputData,
    fetchVesselSensitivityInput: useCallback(fetchVesselSensitivityInput, []),
    getVesselSensitivityInputLoading,
  }
}
